import { useState, useEffect } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { NAV, IMAGES } from "@/lib/site-data";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 bg-[#23272b] border-b border-white/10 transition-shadow duration-300 ${scrolled ? "shadow-[0_12px_40px_rgba(0,0,0,0.45)]" : ""}`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between h-[88px]">
        <a data-testid="header-logo" href="#top" className="flex items-center shrink-0">
          <img src={IMAGES.logo} alt="Ringel Fenstertechnik" className="h-16 sm:h-[72px] w-auto" />
        </a>

        <nav data-testid="main-nav" className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.href}
              data-testid={`nav-${n.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              href={n.href}
              className="font-display text-sm font-medium tracking-wide text-white/75 hover:text-white transition-colors duration-200 relative after:absolute after:-bottom-1.5 after:left-0 after:h-[2px] after:w-0 after:bg-[#e2001a] after:transition-[width] after:duration-300 hover:after:w-full"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            data-testid="header-cta"
            href="#kontakt"
            className="hidden sm:inline-flex items-center gap-2 bg-[#e2001a] hover:bg-[#b80016] text-white font-display font-semibold text-sm px-6 py-3 rounded-full transition-colors duration-300 group"
          >
            Angebot anfordern
            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden text-white p-2"
            aria-label="Menü"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <nav data-testid="mobile-nav" className="lg:hidden bg-[#1e2226] border-t border-white/10 px-5 py-4 flex flex-col gap-1">
          {NAV.map((n) => (
            <a
              key={n.href}
              data-testid={`mobile-nav-${n.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              href={n.href}
              onClick={() => setOpen(false)}
              className="font-display text-white/85 text-base py-3 border-b border-white/5 hover:text-white transition-colors duration-200"
            >
              {n.label}
            </a>
          ))}
          <a data-testid="mobile-nav-cta" href="#kontakt" onClick={() => setOpen(false)} className="mt-3 inline-flex justify-center bg-[#e2001a] text-white font-display font-semibold px-6 py-3 rounded-full">
            Angebot anfordern
          </a>
        </nav>
      )}
    </header>
  );
};
